import { RouteParameters } from "./route-parameters";

const RISK_ROUTING = {
  CREATE: {
    ROOT: `/dashboard/:${RouteParameters.AIRPLANE_ID}/operations/risk/create`,
    [RouteParameters.RISK_FORM_ID]: {
      ROOT: `/dashboard/:${RouteParameters.AIRPLANE_ID}/operations/risk/create/:${RouteParameters.RISK_FORM_ID}`,
    },
  },
  ROOT: `/dashboard/:${RouteParameters.AIRPLANE_ID}/operations/risk`,
  SELECT: `/dashboard/:${RouteParameters.AIRPLANE_ID}/operations/risk/select`,
  VIEW: `/dashboard/:${RouteParameters.AIRPLANE_ID}/operations/risk/view`,
} as const;

const RISK_ROUTES = [
  RISK_ROUTING.ROOT,
  RISK_ROUTING.CREATE.ROOT,
  RISK_ROUTING.VIEW,
  RISK_ROUTING.SELECT,
  RISK_ROUTING.CREATE[RouteParameters.RISK_FORM_ID].ROOT,
] as const;

export { RISK_ROUTES, RISK_ROUTING };
